import React, { Component } from "react";
import {
    SimpleGrid
} from '@chakra-ui/react';

import HealthFolder from "./Components/Health/HealthFolder";
import LogGrid from "./Components/Logs/LogGrid";
import NabcReplacementGrid from "./Components/NABC/NabcReplacementGrid";

import "../../assets/css/main.css";

export default class MainPage extends Component {
    constructor(props) {
        super(props);
        this.state = {

        }

    }


    render() {
        return (
            <div className="main">
                <HealthFolder 
                    userSession={this.props.userSession}
                />
                <LogGrid
                    title="Log Results (last 72 hours)"
                    hoursBefore={72}
                    returnRowData={this.returnRowData}
                    userSession={this.props.userSession}
                />
                <SimpleGrid minChildWidth='700px'>
                    <NabcReplacementGrid
                        key="NabcShipmentFilter"
                        filterType="NabcShipmentFilter"
                        title="NABC Shipment Filter Replacement Values"
                        userSession={this.props.userSession}
                    />
                    <NabcReplacementGrid
                        key="NabcOpenInventoryFilter"
                        filterType="NabcOpenInventoryFilter"
                        title="NABC Open Inventory Filter Replacement Values"
                        userSession={this.props.userSession}
                    />
                </SimpleGrid>

            </div>
        )

    }
}